import React from "react";
import Button from "@mui/material/Button";
import { Box, SxProps, Theme } from "@mui/material";
import { Link as RouterLink, To } from "react-router-dom";
import { ArrowForward } from "@mui/icons-material";

interface NavButtonProps {
  label: string;
  ariaLabel: string;
  to: To;
  disabled?: boolean;
  boxSx?: SxProps<Theme>;
  buttonSx?: SxProps<Theme>;
}

export const NavButton = ({
  label,
  ariaLabel,
  to,
  disabled = false,
  boxSx,
  buttonSx,
}: NavButtonProps) => {
  return (
    <Box
      my={1}
      display="flex"
      justifyContent="center"
      alignItems="center"
      sx={{ ...boxSx }}
    >
      <Button
        variant="contained"
        color="primary"
        component={RouterLink}
        to={to}
        aria-label={ariaLabel}
        title={ariaLabel}
        disabled={disabled}
        sx={{
          fontSize: { xs: "1.2rem", md: "2rem" },
          py: 1,
          px: 2,
          borderRadius: "10px",
          boxShadow: "0 0 18px 9px rgba(25,118,210,0.65)",
          letterSpacing: 0.4,
          fontWeight: "bold",
          ...buttonSx,
        }}
      >
        {label}
        <ArrowForward sx={{ fontSize: "1em", ml: 0.5 }} />
      </Button>
    </Box>
  );
};
